import React, { useState, useEffect } from 'react';
import { Box} from '@mui/material';
import BusesCheckBoxesModified from './busesCheckBoxes/BusesCheckBoxesModified';
import './SimuladorMapa.css';

const SimuladorMapa = () => {
  const [map, setMap] = useState(null);
  const [selectedElements, setSelectedElements] = useState([]);
  const [mapElements, setMapElements] = useState({});


  useEffect(() => {
    // Ocultar el header y sidebar
    document.querySelector('.header')?.style.setProperty('display', 'none');
    document.querySelector('.drawer')?.style.setProperty('display', 'none');
    document.querySelector('.content')?.style.setProperty('margin-left', '0');

    if (window.google) {
      initMap();
    } else {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD1Nl9yulU0jgl6VRGkK89neIalMrblrws&signed_in=true&callback=initMap`;
      script.async = true;
      document.body.appendChild(script);
      window.initMap = initMap;
    }

    // Limpieza al desmontar el componente
    return () => {
      document.querySelector('.header')?.style.setProperty('display', '');
      document.querySelector('.drawer')?.style.setProperty('display', '');
      document.querySelector('.content')?.style.setProperty('margin-left', '');
      window.initMap = null;

    };
  }, []);

  const initMap = () => {
    const mapInstance = new window.google.maps.Map(document.getElementById('map-simulador'), {
      center: { lat: -34.603722, lng: -58.381592 },
      zoom: 12,
    });
    setMap(mapInstance);
  };

  

  //funciona para manejo de seleccion de lineas 
  const handleSelectElement = (id, path, type, color) => {
    if (!map) return;

    // Crear la polilínea y guardar su referencia
    const polyline = new window.google.maps.Polyline({
      path: path.map(p => ({ lat: p.lat, lng: p.lng })),
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 1.0,
      strokeWeight: 3,
      map: map
    });

    // Guardar la referencia en el estado
    setMapElements(prev => ({
      ...prev,
      [id]: polyline
    }));

    setSelectedElements(prev => [...prev, { id, path, type, color }]);
  };

  const handleRemoveElement = (id, type) => {
  // Eliminar exactamente la línea especificada y sus variantes (como 1A, 1B)
  Object.keys(mapElements).forEach(key => {
    // Verificamos si la línea base coincide exactamente (sin incluir prefijos)
    const baseKey = key.replace(/[^0-9]/g, '');
    if (baseKey === id) {
      mapElements[key].setMap(null);
      
      // Eliminar la referencia del estado
      setMapElements(prev => {
        const newElements = { ...prev };
        delete newElements[key];
        return newElements;
      });
    }
  });

  setSelectedElements(prev => prev.filter(el => el.id.replace(/[^0-9]/g, '') !== id));
};

  

   return (
    <Box className="simulador-container">
      <Box id="map-simulador" className="map-container"></Box>
      
      {/* Acordeón flotante para las líneas de colectivos */}
      <Box className="modified-floating-accordion">
        <BusesCheckBoxesModified 
          selectedElements={selectedElements}
          handleSelectElement={handleSelectElement}
          handleRemoveElement={handleRemoveElement}
        />
      </Box>
      
    </Box>
  );
};

export default SimuladorMapa;